const CONVERSATION_CHARGE = {
  PAGE_TITLE: 'Conversation Charge | Raychat',

  HEADING_TITLE: 'Conversation Charge',
  HEADING_SUBTITLE:
    'You can charge your number of calls by selecting the number of charges you need and continue paying.',

  CONVERSATIN_COUNT: 'Conversation Count',
  PRICE_PER_CONV: 'The price of each conversation for your package is #price#$',
  CONV_CHARGE: 'Conversation Charge',
  TAX: 'Tax',
  POSTING: 'Posting',
  TOTAL: 'Total',
  SEND_OFFICIAL_INVOICE: 'Issuing and sending official invoices',
  CONTINUE_PURCHASE: 'Continue Purchase',
  REDIRECT_TO_PAYMENT_GATEWAY: 'Redirect to Payment Gateway',
  UNIT: '$',
  INFO_EDIT_BTN: 'Edit',
};

export default CONVERSATION_CHARGE;
